import { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { member } from "../../components/apipath";
import { motion } from "framer-motion";

function Member() {
    const auth = JSON.parse(localStorage.getItem('auth'));
    const [memStatus, setMemStatus] = useState(null); // 0 = 未付費, 1 = 付費學員
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (auth?.mem_id) {
            axios.get(`${member}status/${auth.mem_id}`)
                .then(res => {
                    setMemStatus(res.data.mem_status);
                    setLoading(false);
                });
        }
    }, []);

    if (!auth || !auth.token) {
        Swal.fire({
            icon: "warning",
            color: "#224040",
            text: "尚未登入會員",
        });
        return <Navigate to="/member/memberlogin" replace />;
    }

    if (loading) return <div className="text-center mt-5">載入中...</div>;

    const isStudent = memStatus === 1;

    return (
        <>
            <div className="banner">
                <motion.div
                    initial={{ opacity: 0, x: -100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4, default: { ease: "linear" } }}>
                    <img src="/memberImg/member_banner.jpg" alt="" />
                </motion.div>
                <div className="memberbannertext dis">
                    <div className="lgtext dis">
                        <div className="lxtext mb-5 dis">Direct Line</div>
                        {isStudent ? '學員專區' : '會員專區'}<br />
                    </div>
                    您好，歡迎使用捷進 Becker {isStudent ? '學員' : '會員'}專區<br />
                </div>
            </div>

            <div className="container mb100">
                <div className="beckertitlename mt100">
                    {isStudent ? '學員專區' : '會員專區'}
                </div>

                <div className="memberbar mt100 mb100">
                    <Link to="./memarea">
                        <div className="membersq mainbg">
                            基本<div className="fs-3">資料編輯</div>
                        </div>
                    </Link>
                    {/* {!isStudent && (
                        <>
                            <Link to="../audition">
                                <div className="membersq greenbg">
                                    試聽<div className="fs-3">中文課程</div>
                                </div>
                            </Link>
                        </>
                    )} */}

                    {isStudent && (
                        <>
                            <Link to="./extend">
                                <div className="membersq yellowbg">軟體<div className="fs-3">展延申請</div></div>
                            </Link>
                            <Link to="./consult">
                                <div className="membersq greenbg">中文<div className="fs-3">線上發問系統</div></div>
                            </Link>
                        </>
                    )}
                </div>

                {isStudent && (
                    <div className="memberbar">
                        <Link to="./point">
                            <div className="membersq primary500bg">雲端<div className="fs-3">課程與申請</div></div>
                        </Link>
                        <Link to="./book">
                            <div className="membersq redbg">領書<div className="fs-3">預約&申請</div></div>
                        </Link>
                        <Link to="./add">
                            <div className="membersq mainbg">Becker<div className="fs-3">加購申請</div></div>
                        </Link>
                    </div>
                )}
            </div>
        </>
    );
}

export default Member;
